module.exports = __webpack_public_path__ + "static/media/PES.7556c4d3.PNG";